// extracted by mini-css-extract-plugin
module.exports = {"deleteIcon":"JobsForm_deleteIcon__3g3BE","addIcon":"JobsForm_addIcon__3BvI6"};